import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const orbitaxConnectRoutes: Routes = [
  {
    path: 'orbitax-connect/analytics',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'orbitax-connect/pipelines',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'orbitax-connect/pipelines/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path     : 'orbitax-connect/select-pipeline/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'orbitax-connect/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  }
];
